export interface Account {
  id: number
  role: string
  lang: string
  email: string
  study_id: number
  created_at: string
  updated_at: string
  notification: boolean
  communication: boolean
}

export interface IPatient {
  id: number
  surgery_date: string
  name: string
  surname: string
}

export interface IScore {
  id: number
  patient_id: number
  created_at: string
  updated_at: string
  physical_autonomy: number
  pain_management: number
  life_hygiene: number
  personal_life: number
  professional_life: number
  life_quality: number
  walking: number
  engagement: number
}

export interface IAnalyze {
  id: number
  patient_id: number
  created_at: string
  updated_at: string
  prediction: number
}

export interface IPatientSurvey {
  id: number
  active: boolean
  completed: boolean
  survey_reference: string
  survey_id: number
  start_date: number | null
  end_date: number
  submission: ISubmission
}

export interface ISubmission {
  created_at: string
  answers: Array<IAnswer>
}

export interface IAnswer {
  value: number | string | Array<number>
  question_id: number
}

export interface IStudy {
  id: number
  name: string
  created_at: string
  updated_at: string
  lang: string
  surveys_answered: number
  patients: Array<IPatient>
  scores: Array<IScore>
  analyzes: Array<IAnalyze>
  patient_surveys: Array<IPatientSurvey>
}

export interface IStudyDetails {
  id: number
  name: string
  created_at: string
  updated_at: string
  lang: string
  patient: IPatient
  patient_surveys: Array<IPatientSurvey>
  practitioner_surveys: Array<IPatientSurvey>
}
export interface IOptions {
  value: number
  label: string
}

export interface IQuestion {
  id: number
  question_reference: string
  content: string
  kind: string
  options: Array<IOptions>
  value: string | undefined
}

export interface ISurvey {
  survey_reference: string
  content: string
  description: string
  kind: string
  questions: Array<IQuestion>
}

export type StudyOverview = {
  id: number
  name: string
  lang: string
}

export type PatientOverview = {
  id: number
  surgery_date: string
  signup_date: string
  birthday: string
}

export type GroupOverviewStudy = {
  patients: Array<PatientOverview>
  scores: Array<IScore>
  analyzes: number
  submissions: number
  study: StudyOverview
  pracitioner: {
    id: number
    name: string
    surname: string
  }
}

export type GroupOverviewStudies = Array<GroupOverviewStudy>

export type InvitationLock = {
  id: number
  user_id: number
  study_id: number
  email: string
  invitation_token: string
  created_at: string
  updated_at: string
}

export type PostInvitationLockBody = {
  invitation_lock: {
    study_id: number
    email: string
  }
}

export enum PatientsFileTabsEnum {
  DATA = "data",
  SURVEYS = "surveys"
}

export type TSurvey = {
  survey_reference: string
  content: string
  description: string
  kind: string
  questions: Array<Question>
}

export type Question = {
  id: number
  question_reference: string
  content: string
  kind: string
  options: Array<IOptions>
  value: string | undefined
  filtered?: boolean
}
export type PatientSurvey = {
  id: number
  active: boolean
  completed: boolean
  survey_reference: string
  survey_id: number
  patient_id: number
  submission: ISubmission
}

export type PatientsSurveysSubmissionPostBody = {
  submission: {
    answers_attributes: Array<IAnswer>
  }
}
